import { snakeCase, camelCase, isObject } from "lodash";
var Formatter = /** @class */ (function () {
    function Formatter() {
    }
    Formatter.prototype.centsToDollars = function (amount, addCurrency) {
        if (addCurrency === void 0) { addCurrency = false; }
        if (!amount) {
            return '-';
        }
        var formattedAmount = (amount / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        return (addCurrency) ? '$' + formattedAmount : formattedAmount;
    };
    Formatter.prototype.nameToRouteName = function (title) {
        return title.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-');
    };
    Formatter.prototype.formatAptNum = function (location) {
        if (!isObject(location)) {
            return '';
        }
        if (typeof location['getAptNum'] !== 'function') {
            return '';
        }
        // @ts-ignore
        var aptNum = location.getAptNum();
        if (aptNum) {
            return "#" + aptNum;
        }
    };
    Formatter.prototype.formatAddress = function (address) {
        if (address.addressComponents) {
            var formattedAddress = address.addressComponents.streetNumber.shortName + " " + address.addressComponents.streetName.shortName;
            if (address.aptNum) {
                formattedAddress += " " + address.aptNum + ",";
            }
            formattedAddress += " " + address.addressComponents.locality.shortName + ", " + address.addressComponents.postalCode.shortName + " " + address.addressComponents.state.shortName;
            return formattedAddress;
        }
        else {
            return address.formattedAddress;
        }
    };
    // convert to snake_case. Helpful for api calls
    Formatter.prototype.convertKeyCase = function (obj, propCase) {
        if (propCase === void 0) { propCase = "camelCase"; }
        var convertedObj = {};
        var casify = null;
        switch (propCase) {
            case "snakeCase":
                casify = snakeCase;
                break;
            case "camelCase":
                casify = camelCase;
                break;
            default:
                casify = camelCase;
        }
        for (var key in obj) {
            convertedObj[casify(key)] = obj[key];
        }
        return convertedObj;
    };
    return Formatter;
}());
export default new Formatter();



//////////////////
// WEBPACK FOOTER
// ./src/utils/Formatter.ts
// module id = qDvh
// module chunks = 18